import { render, staticRenderFns } from "./DesignationRearrange.vue?vue&type=template&id=2d0d3b04"
import script from "./DesignationRearrange.vue?vue&type=script&lang=js"
export * from "./DesignationRearrange.vue?vue&type=script&lang=js"
import style0 from "./DesignationRearrange.vue?vue&type=style&index=0&id=2d0d3b04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports